import { LoggerService } from '@tablesready/frontend-logger';

export abstract class AudioService {
  private smsElement = new Audio();
  private checkInElement = new Audio();

  constructor( private loggerService: LoggerService) {}

  playSMSConfirmation() {
    this.smsElement.src = './assets/audio/alert_pop.mp3';
    this.smsElement.load();
    this.smsElement.play()
    .catch((error) => {
      this.loggerService.warn(`AudioService Error: ${error}`);
    });
  }

  playCheckInConfirmation() {
    this.checkInElement.src = './assets/audio/got-it-done.mp3';
    this.checkInElement.load();
    this.checkInElement.play()
      .then((res) => {
      })
    .catch((error) => {
      this.loggerService.warn(`AudioService Error: ${error}`);
    });
  }
}
